import type { Config } from '@grandvisionhq/shipping'

export const getDeliveryIndicatorConfig = (): Config => ({
  inventoryChannels: {
    'f5e264d7-74c3-4333-8d12-090a2489189b': {
      // online-store TEST
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
    '0517d1ff-8b24-4ff7-aa91-db5b2bd3eb19': {
      // online-store ACCT
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
    'c389415c-b5e8-489b-8b84-b0e76a7539b0': {
      // online-store PROD
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
  },
  missingInventoryChannelStrategy: {
    expectedDeliveryDays: '8+',
  },
  nextDayDeliveryTimeLimit: '18:00',
  productTypeDeliveryConfig: [
    {
      type: 'GLASSES_BUNDLE',
      expectedDeliveryDays: '7-10',
    },
    {
      type: 'NON_PRESCRIPTION_BUNDLE',
      expectedDeliveryDays: '5',
    },
    {
      type: 'CONTACT_LENSES',
      expectedDeliveryDays: '3',
    },
    {
      type: 'REGULAR',
      expectedDeliveryDays: '1',
    },
  ],
})
